<template>
  <div>
    <ContentHeader path-set-type="append" :gameplan-nav="false" />
    <div class="content-wrapper" v-loading="loading">
      <el-row>
        <div class="mask" v-if="isMask"></div>
        <div class="title">活动主题信息</div>
        <div class="card-box">
          <div class="card is-hover-shadow">
            <div class="left">
              <div class="left-top">
                <div class="left-top-left">
                  <div class="top-name">{{themeBasic.themeName}}</div>
                  <div class="top-sign">{{getBluename(themeBasic.orgLevel)}}</div>
                </div>
                <div class="left-top-right">
                  <span>{{ getTime(themeBasic.themeStartTime) }}</span>
                  <span style="margin: 0px 5px">-</span>
                  <span>{{ getTime(themeBasic.themeEndTime) }}</span>
                </div>
              </div>
              <div class="left-third">
                <div class="flex">
                  <div style="margin-right:50px;margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{prInfo}}</div>
                  <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{brandInfo}}</div>
                </div>
              </div>
              <div class="left-third">
                <div class="left-third-left">
                    <span>活动执行数据收集模板</span>
                    <span @click="viewChangepop()" style="color: #409EFF;margin-left: 20px;cursor: pointer;">配置详情</span>
                </div>
                <div class="left-third-right">
                    <span class="text">活动执行手册</span>
                    <span class="text" style="color: #409EFF;margin-left: 20px;cursor: pointer;">
                      <span @click="viewPdf()" v-if="themeBasic.manualFileName && themeBasic.manualFileUri">{{ themeBasic.manualFileName }}</span>
                      <span v-else>暂无附件</span>
                    </span>
                </div>
              </div>
              <!-- <div class="left-fouth" v-if="themeBasic.skuDTOList">
                <div class="left-fouth-left">
                    <span>活动SKU：</span>
                </div>
                <div class="left-fouth-right">
                    <span>{{getSKU(themeBasic.skuDTOList,'、')}}</span>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div
          class="cross"
          v-for="item of fullConfig"
          :key="item.themeStyleCode"
        >
          <QuotaPop
            :channelForm="item"
            :dataForm="detailList"
            @saveChange="saveChange"
          >
          </QuotaPop>
        </div>
        <!-- 底部按钮 -->
        <div class="bottom-btn">
          <DialogPop
            v-if="isSubmit"
            @confirm="submitChange"
            isType="0"
            btnText="提交变更"
            :center-text="changeText"
          >
          </DialogPop>
          <DialogPop
            v-else
            @confirm="confirmAmount"
            isType="0"
            btnText="确认数额"
            centerText="是否确认数额？"
          >
          </DialogPop>
        </div>
        <div v-if="showChangepop" class="changePop">
            <configBuChangePop
            @closeChangepop="closeChangepop"
            :themeId="themeId"
            ></configBuChangePop>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { commonUtils } from '@/utils/common'
import gameplanApi from "../../api/gameplan";
import ContentHeader from "@/components/content-header";
import QuotaPop from "./components/quotaWait-confirmed-pop.vue";
import DialogPop from "./components/dialog-pop.vue";
import configBuChangePop from './components/config-buChange-pop.vue'
export default {
  name: "quotaWait-confirmed-detail",
  components: {
    ContentHeader,
    QuotaPop,
    DialogPop,
    configBuChangePop
  },
  data() {
    return {
      themeBasic: {},
      detailList: {},
      fullConfig: [],
      themeId: "",
      subList: [],
      loading: false,
      leftValue: 0,
      showChangepop: false,
      isMask:false,
      prInfo:'',
      brandInfo:''
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    changeText () {
      // 剩余可分配金额
      let num = 0
      if (this.subList.length > 0) {
        for (let item of this.subList) {
          if (item.subAssignList[0].redNumall > 0) {
            num = num + item.subAssignList[0].redNumall
          }
        }
      }
      // console.log(num,'num');
      // return this.leftValue > 0 ? '当前还有场次未分配，是否确认提交变更？' : '是否确认提交变更？'
      return num > 0 ? '当前还有预算未分配，是否确认提交变更？' : '是否确认提交变更？'
    },
    isSubmit () {
      return this.subList.length > 0
    }
  },
  watch: {},
  created() {
    this.themeId = this.$route.query.themeId;
    this.init();
  },
  mounted() {},
  updated() {},
  methods: {
    init() {
      this.getDetailinfo();
    },
    lockScroll() {
      let widthBar = 17, root = document.documentElement;
      if (typeof window.innerWidth == 'number') {
          widthBar = window.innerWidth - root.clientWidth;
      }
      root.style.overflow = 'hidden';
      root.style.borderRight = widthBar + 'px solid transparent';
    },
    unlockScroll() {
      let root = document.documentElement;
      root.style.overflow = '';
      root.style.borderRight = '';
    },
    viewPdf () {
      if (this.themeBasic.manualFileUri) {
          window.open(commonUtils.getImageUrl(this.themeBasic.manualFileUri))
      } else {
          console.log('manualFileUri为空');
      }
    },
    viewChangepop () {
        this.isMask = true
        this.showChangepop = true
        this.lockScroll()
    },
    closeChangepop () {
        this.isMask = false
        this.showChangepop = false
        this.unlockScroll()
    },
    getSKU (arr,sign) {
      if (arr && arr.length > 0) {
        let name = arr.map((item)=>{
          return item.skuName
        }).join(sign)
        return name
      } else {
        return '暂无数据'
      }
    },
    getBluename (name) {
      if (name == 'region') {
          return 'Region'
      } else if (name == 'bu') {
          return 'BU'
      } else if (name == 'hq') {
          return 'HQ'
      } else {
          return 'error'
      }
    },
    getChannel(a, b) {
      let themeChannels = a || [];
      let arr = themeChannels
        .map((item) => {
          return item.themeChannelEnName;
        })
        .join(b);
      return arr;
    },
    getShowDetail(){
      let brandInfo = []
      let prInfo = []
      const gpPrDTOList = this.themeBasic.gpPrDTOList
      if(gpPrDTOList){
        gpPrDTOList.forEach(item=>{
          let data = ''
          if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
          else data = item.brandName||item.subBrandName
          if(brandInfo.indexOf(data)===-1) {
            brandInfo.push(data)
          }
          prInfo.push(item.prNumber+'-'+item.prName)
        })
        this.brandInfo = brandInfo.join('、')
        this.prInfo = prInfo.join('、')
      }
    },
    getTime(timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(parseInt(timestamp)); // 时间戳为13位的话需要parseInt下
        const Y = date.getFullYear() + "-";
        const M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        const D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        return Y + M + D;
      }
    },
    async getDetailinfo() {
      let params = {
        'themeId': this.themeId,
        'detailOrConfig':'1'
      };
      this.loading = true
      let { data } = await gameplanApi.getGamepalnThemeInfo(params);
      if (data.resultCode == '0') {
        this.themeBasic = data.resultData.themeInfo.themeBasic;
        this.getShowDetail()
        // this.fullConfig = data.resultData.themeInfo.themeBasic.themeChannels;
        // this.detailList = data.resultData.themeInfo.detailList;
        let detailList = data.resultData.themeInfo.detailList;
        for (let i = 0; i < detailList.length; i++) {
          if (detailList[i].curAssignList == null || detailList[i].curAssignList.length == 0 || detailList[i].curAssignList[0].assignStatus !== 30) {
            detailList.splice(i,1)
            i--
          }
        }
        this.detailList = detailList
        let arr = []
        for (let item of this.detailList) {
          if (item.themeDetail.themeChannelName && item.themeDetail.themeChannelCode) {
             arr.push({
              'themeChannelCode':item.themeDetail.themeChannelCode,
              'themeChannelName':item.themeDetail.themeChannelName.split('|')[0],
              'themeChannelEnName':item.themeDetail.themeChannelName.split('|')[1],
              'themeStyleCode':item.themeDetail.themeStyleCode
            })
          }
        }
        let len = arr.length
        for (let i = 0; i < len; i++) {
          for (let j = i + 1; j < len; j++) {
            if (arr[i].themeStyleCode === arr[j].themeStyleCode) {
              arr.splice(j, 1)
              len-- // 减少循环次数提高性能
              j-- // 保证j的值自加后不变
            }
          }
        }
        this.fullConfig = arr
        this.loading = false
      }
    },
    // 额度修改接口
    assignConfirm(params) {
      this.loading = true
      gameplanApi.getGamepalnAssignconfirm(params).then((res) => {
        this.loading = false
        if (res.data.resultCode == "0") {
          if (params.confirmOrSubmit == false) {
            this.$message.success("提交变更成功");
            this.$router.replace({ path: "/gameplan/quotaWait-confirmed" })
          } else {
            this.$message.success("确认数额成功");
            this.$router.replace({ path: "/gameplan/quotaWait-confirmed" })
          }
        }
      }).catch(() => {
        this.loading = false
      })
    },

    // 保存变更
    saveChange(item) {
      // console.log(item,'保存变更');
      if (item.list1.isInterval) {
        item.list1.nextLevelRatenew =  item.list1.nextLevelRate
      } else {
        item.list1.nextLevelRatenew = item.popData[0].themeDetail.nextLevelRate
      }
      let a = [];
      if (!item.popData || item.popData.length === 0) {
        return
      }
      this.leftValue = 0
      if (item.popData.length > 0) {
        let obj1 = {
          subAssignList: [
            {
              assignId: item.list1.assignId,
              assignQty: item.list1.assignQty,
              buChangeQty: item.list1.buChangeQty,
              themeDetailId: item.list1.themeDetailId,
              themeId: item.list1.themeId,
              assignEndTime:item.assignEndTime,
              assignStartTime:item.assignStartTime,
              redNumall:item.redNumall
            },
          ],
          themeDetail: {
            themeDetailId: item.popData[0].themeDetail.themeDetailId,
            themeId: item.popData[0].themeDetail.themeId,
            themeChannelCode: item.popData[0].themeDetail.themeChannelCode,
            themeChannelName: item.popData[0].themeDetail.themeChannelName,
            themeLevelCode: item.popData[0].themeDetail.themeLevelCode,
            themeLevelName: item.popData[0].themeDetail.themeLevelName,
            nextLevelCode: item.popData[0].themeDetail.nextLevelCode,
            // nextLevelRate: item.popData[0].themeDetail.nextLevelRate,
            nextLevelRate: item.list1.nextLevelRatenew,
            themeStyleCode: item.popData[0].themeDetail.themeStyleCode,
            themeStyleName: item.popData[0].themeDetail.themeStyleName,
            investUnit: item.popData[0].themeDetail.investUnit,
            needTransitions:item.popData[0].themeDetail.needTransitions,
            perExecDays:item.popData[0].themeDetail.perExecDays
          }
        };
        a.push(obj1)
        this.leftValue+= item.list1.leftNum || 0
      }
      if (item.popData.length > 1) {
        let obj2 = {
          subAssignList: [
            {
              assignId: item.list2.assignId,
              // "buChangeQty": item.list2.assignQty,
              assignQty: item.list2.assignQty,
              buChangeQty: item.list2.buChangeQty,
              themeDetailId: item.list2.themeDetailId,
              themeId: item.list2.themeId,
              assignEndTime:item.assignEndTime,
              assignStartTime:item.assignStartTime,
            },
          ],
          themeDetail: {
            themeDetailId: item.popData[1].themeDetail.themeDetailId,
            themeId: item.popData[1].themeDetail.themeId,
            themeChannelCode: item.popData[1].themeDetail.themeChannelCode,
            themeChannelName: item.popData[1].themeDetail.themeChannelName,
            themeLevelCode: item.popData[1].themeDetail.themeLevelCode,
            themeLevelName: item.popData[1].themeDetail.themeLevelName,
            nextLevelCode: item.popData[1].themeDetail.nextLevelCode,
            nextLevelRate: item.popData[1].themeDetail.nextLevelRate,
            themeStyleCode: item.popData[1].themeDetail.themeStyleCode,
            themeStyleName: item.popData[1].themeDetail.themeStyleName,
            investUnit: item.popData[1].themeDetail.investUnit,
            needTransitions:item.popData[1].themeDetail.needTransitions,
            perExecDays:item.popData[1].themeDetail.perExecDays
          },
        }
        a.push(obj2)
        this.leftValue+= item.list2.leftNum || 0
      }
      if (item.popData.length > 2) {
        let obj3 = {
          subAssignList: [
            {
              assignId: item.list3.assignId,
              // "buChangeQty": item.list3.assignQty,
              assignQty: item.list3.assignQty,
              buChangeQty: item.list3.buChangeQty,
              themeDetailId: item.list3.themeDetailId,
              themeId: item.list3.themeId,
              assignEndTime:item.assignEndTime,
              assignStartTime:item.assignStartTime,
            },
          ],
          themeDetail: {
            themeDetailId: item.popData[2].themeDetail.themeDetailId,
            themeId: item.popData[2].themeDetail.themeId,
            themeChannelCode: item.popData[2].themeDetail.themeChannelCode,
            themeChannelName: item.popData[2].themeDetail.themeChannelName,
            themeLevelCode: item.popData[2].themeDetail.themeLevelCode,
            themeLevelName: item.popData[2].themeDetail.themeLevelName,
            nextLevelCode: item.popData[2].themeDetail.nextLevelCode,
            nextLevelRate: item.popData[2].themeDetail.nextLevelRate,
            themeStyleCode: item.popData[2].themeDetail.themeStyleCode,
            themeStyleName: item.popData[2].themeDetail.themeStyleName,
            investUnit: item.popData[2].themeDetail.investUnit,
            needTransitions:item.popData[2].themeDetail.needTransitions,
            perExecDays:item.popData[2].themeDetail.perExecDays
          },
        }
        a.push(obj3)
        this.leftValue+= item.list3.leftNum || 0
      }

      for (let i of a) {
        const index = this.subList.findIndex(item => {
          return ( item.subAssignList[0].assignId === i.subAssignList[0].assignId)
          // return (item.themeDetail.themeDetailId === i.themeDetail.themeDetailId && item.subAssignList[0].assignStartTime === i.subAssignList[0].assignStartTime)
        })
        if (item.changeType) {
          if (index < 0) {
            this.subList.push(i)
          } else {
            this.subList.splice(index, 1, i)
          }
        } else {
          this.subList.splice(index, 1)
        }
      }
      // console.log(this.subList,'this.subList');
    },
    // 提交变更
    submitChange(item) {
      let params = {
        confirmOrSubmit: false,
        detailList: this.subList,
      }
      // console.log(params,'提交变更');
      this.assignConfirm(params);
    },
    // 确认数额
    confirmAmount() {
      let arr = [];
      for (let item1 of this.detailList) {
        for (let item2  of item1.curAssignList) {
          arr.push({
            subAssignList: [
              {
                assignId: item2.assignId,
                // assignQty:item2.assignQty,
                // buChangeQty: item2.buChangeQty,
                themeDetailId: item2.themeDetailId,
                themeId: item2.themeId,
                assignEndTime:item2.assignEndTime,
                assignStartTime:item2.assignStartTime,
              },
            ],
            themeDetail: {
              themeDetailId: item1.themeDetail.themeDetailId,
              themeId: item1.themeDetail.themeId,
              themeChannelCode: item1.themeDetail.themeChannelCode,
              themeChannelName: item1.themeDetail.themeChannelName,
              themeLevelCode: item1.themeDetail.themeLevelCode,
              themeLevelName: item1.themeDetail.themeLevelName,
              nextLevelCode: item1.themeDetail.nextLevelCode,
              nextLevelRate: item1.themeDetail.nextLevelRate,
              themeStyleCode: item1.themeDetail.themeStyleCode,
              themeStyleName: item1.themeDetail.themeStyleName,
              investUnit: item1.themeDetail.investUnit,
              needTransitions:item1.themeDetail.needTransitions,
              perExecDays:item1.themeDetail.perExecDays
            },
          });
        }
      }
      let params = {
        confirmOrSubmit: true,
        detailList: arr,
      };
      // console.log(params,'确认数额');
      this.assignConfirm(params);
    },
  },
};
</script>
<style lang="scss" scoped>
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;
  .title {
    height: 50px;
    line-height: 50px;
    text-align: left;
    color: rgba(16, 16, 16, 1);
    font-size: 18px;
    font-weight: 600;
    margin-top: -40px;
  }
  .card-box {
    .card {
      display: flex;
      justify-content: flex-start;
      padding: 10px 20px 10px 20px;
      background-color: #ffffff;
      border-radius: 8px;
      font-size: 14px;
      .left {
        text-align: left;
        color: #101010;
        flex: 1;
        .left-top {
          // line-height: 27px;
          display: flex;
          .left-top-left {
            width: 80%;
            font-size: 18px;
            display: flex;
            .top-name {
                font-weight: 600;
                // padding: 2px 0px;
                // line-height: 20px;
                word-wrap: break-word;
                word-break: normal;
                word-break: break-all;
            }
            .top-sign {
              // padding: 2px 8px;
              color: #FFFFFF;
              background-color: #40A5EE;
              margin-left: 10px;
              // border-radius: 3px;
              // height: 20px;
              padding: 0px 8px;
              line-height: 18px;
              height: 18px;
              font-size: 14px;
              margin-top: 3px;
              font-weight: 600;
            }
          }
          .left-top-right {
            flex: 1;
            font-size: 14px;
            text-align: right;
            word-wrap: break-word;
            word-break: normal;
            word-break: break-all;
            line-height: 20px;
          }
        }
        .left-third {
          font-size: 14px;
          //height: 20px;
          line-height: 20px;
          margin-top: 12px;
          display: flex;
          justify-content: flex-start;
          .left-third-left {
              display: flex;
              justify-content: flex-start;
              margin-right: 80px;
          }
          .left-third-right {
              display: flex;
              justify-content: flex-start;
              .img {
              width: 20px;
              margin-right: 3px;
              }
              // .text {
              //     margin: 0px 3px 0px 3px ;
              //     // color: #539EFE;
              // }
          }
        }
        .left-fouth {
          display: flex;
          font-size: 14px;
          line-height: 20px;
          margin-top: 12px;
          .left-fouth-left {
            width: 70px;
          }
          .left-fouth-right {
            flex: 1;
          }
        }
      }
      .right {
        width: 20%;
        text-align: right;
        .right-time {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
  .bottom-btn {
    display: flex;
    justify-content: center;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    text-align: center;
    margin-top: 70px;
  }
  .changePop {
    position: fixed;
    top: 5vh;
    left: calc((100vw - 800px)/2);
    width: 800px;
    padding: 20px;
    background-color: #FFFFFF;
    border-radius: 10px;
    z-index: 3;
    max-height: 90vh;
}
.mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.7) ;
    z-index: 3;
}
}
.flex{
    display:flex;
    flex-wrap:wrap;
  }
</style>
